import { useTranslation } from 'react-i18next'
import style from "../../../sass/pages/shipment/shipment.module.scss";
import { useRef } from 'react';
import { pushAlert } from '../../alerts/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import { sendETGBBillDocument, selectShipmentETGBBillDocumentError, selectShipmentETGBBillDocumentStatus, selectShipment } from '../shipmentSlice';
import { useState } from 'react';
import { useEffect } from 'react';
import { Hidden } from '@mui/material';
import WhiteSpinner from '../../../components/loaders/WhiteSpinner';

const SendETGBBillDocument = ({ shipmentID, fileName }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()


    const fileInputRef = useRef(null)

    const shipment = useSelector(selectShipment)

    const status = useSelector(selectShipmentETGBBillDocumentStatus)
    const error = useSelector(selectShipmentETGBBillDocumentError)

    const handleInputChange = () => {
        let files = fileInputRef.current.files
        if (files.length <= 0) {
            return
        }

        let file = files[0]
        dispatch(sendETGBBillDocument({ shipmentID, file }))
    }

    useEffect(() => {
        if (status === "fulfilled") {
            fileInputRef.current.value = ""
            dispatch(pushAlert({
                type: "success",
                message: t("shipment.additional_files.file_successfully_uploaded"),
                delay: 2000,
            }))
        }
    }, [status, dispatch])
    
    useEffect(() => {
        if (error) {
            dispatch(pushAlert({
                type: "danger",
                message: t(error),
                delay: 2000,
            }))
        }
    }, [error, dispatch])    

    return (
        <div className='flex justify-left items-center flex-wrap gap-x-4 gap-y-2'>
            {fileName 
                ? <span className="text-left text-xs sm:text-basic font-medium">
                    {t("shipment.additional_files.etgb_bill_pinned")}: {fileName} 
                </span>
                : <span className="text-left text-xs sm:text-basic font-medium">
                    {t("shipment.additional_files.pin_etgb_bill")}
                </span>
            }
            {
                shipment && !shipment.blocked &&
                <div className='w-fit text-left' style={{minWidth:"300px", maxWidth:"300px"}}>
                    <label 
                        htmlFor="etgbBillDocument"
                        className={`${style.btn} ${style["btn-primary"]} font-normal w-full text-sm text-center`}
                        style={{
                            display: "inline-block",
                            minWidth:"220px", 
                            maxWidth:"220px",
                            padding: "3px 10px"
                        }}
                    >
                        {
                            status === "pending" ?
                            (
                                <WhiteSpinner />
                            ) :
                            (
                                fileName ?
                                t("shipment.additional_files.upload_new_pdf_file") :
                                t("shipment.additional_files.upload_pdf_file")
                            )
                        }
                    </label>
                    <input
                        style={{ visibility: "hidden", width: 0, height: 0 }}
                        id="etgbBillDocument"
                        type="file"
                        accept="application/pdf"
                        ref={fileInputRef}
                        onChange={handleInputChange}
                    />
                </div>
            }
        </div>
    )
}

export default SendETGBBillDocument